import { render } from "./DcsReadingsView.vue?vue&type=template&id=23b8055c&scoped=true&ts=true"
import script from "./DcsReadingsView.vue?vue&type=script&lang=ts"
export * from "./DcsReadingsView.vue?vue&type=script&lang=ts"

import "./DcsReadingsView.vue?vue&type=style&index=0&id=23b8055c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b8055c"]])

export default __exports__